import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  public static BASE_URL: string = environment.baseApiUrl;

  constructor() { }
  public static log(message: string, ...params: any[]) {
    if(_.includes(window.location.href, 'lg=1')) {
      console.log(message, ...params);
    }
  }
}
